import { render, staticRenderFns } from "./FinancialOpportunity.vue?vue&type=template&id=6ef8627c&scoped=true&"
import script from "./FinancialOpportunity.vue?vue&type=script&lang=js&"
export * from "./FinancialOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./FinancialOpportunity.vue?vue&type=style&index=0&id=6ef8627c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef8627c",
  null
  
)

export default component.exports